import React from "react";

import "./staffing_request_overview_tab.less";
import { WorkloadTable } from "@src/components/workload_table";
import { ProjectInformationCard } from "@src/features/staffing_request_details/components/project_information_card";
import { StaffingRequestInformationCard } from "@src/features/staffing_request_details/components/staffing_request_information_card";
import { RequestOverviewDetails } from "@src/types";
import { Spin, Row, Col } from "antd";

import { mapRowData } from "../../utils/staffing_request_workload_table_utils";

interface StaffingRequestOverviewTabProps {
  request: RequestOverviewDetails;
  isLoading: boolean;
}

const StaffingRequestOverviewTab: React.FC<StaffingRequestOverviewTabProps> = ({
  request,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <div className="staffing-request-overview">
        <Spin data-testid="loading-spinner" />
      </div>
    );
  }

  return (
    <div className="staffing-request-overview">
      <Row gutter={[10, 0]}>
        <Col span={12}>
          <ProjectInformationCard request={request} />
        </Col>
        <Col span={12}>
          <StaffingRequestInformationCard request={request} />
        </Col>
      </Row>
      {!request.isOutdated && (
        <WorkloadTable requestRowData={mapRowData(request)} />
      )}
    </div>
  );
};
export default StaffingRequestOverviewTab;
